import axios from '../library/axiosConfig'
import qs from 'qs'

let operationURL = `${axios.defaults.api}/renter-operation`;

export default {
  sendRedPacket(data) {
    return axios.post(`/redpacket/sendredpacket`, data, {baseURL: axios.defaults.renterOperation});
  },
  //  账单信息(未/已支付)
  getBillSimpleInfo(data) {
    return axios.get(`/rentercenter/v1/leasehold/v2/getBillSimpleInfo`, {params: data, baseURL: operationURL})
  },
  //  租约列表(更多租约)
  getLeaseListForBill(data) {
    return axios.get(`/rentercenter/v1/leasehold/bill/contracts`, {params: data, baseURL: operationURL})
  },
  //  租约信息(账单)
  getOrderSimpleInfo(data) {
    return axios.get(`/rentercenter/v1/leasehold/getOrderSimpleInfo`, {params: data, baseURL: operationURL})
  },
  //  账单明细(详情)
  getBillDetailInfo(data) {
    return axios.get(`/rentercenter/v1/leasehold/v2/getBillDetailInfo`, {params: data, baseURL: operationURL})
  },
  //  账单支付
  billPay(data) {
    return axios.get(`/rentercenter/v1/leasehold/billPay`, {params: data, baseURL: operationURL})
  },
  //  租约列表 （小程序，包括二房东，经纪人；非小程序，只有二房东租约）
  leaseholdContracts(data) {
    return axios.get(`/rentercenter/v3/leasehold/contracts`, {params: data, baseURL: operationURL})
  },
  //  租约列表 （小程序，包括二房东，经纪人；非小程序，只有二房东租约）
  brokerMobile(data) {
    return axios.get(`/rentercenter/v1/leasehold/renter/broker/mobile`, {params: data, baseURL: operationURL})
  },
  //  租约详情 contractId为租约id
  leaseholdContractDetail(data) {
    return axios.get(`/rentercenter/v1/leasehold/contracts/${data.params}`, {baseURL: operationURL})
  },
  //  签署合同
  contractsSign(data) {
    return axios.get(`/v1/leasehold/contracts/${data.params}/sign`, {baseURL: operationURL})
  },
  //  预览签署合同
  contractsSignPre(data) {
    return axios.get(`/rentercenter/v1/leasehold/contracts/${data.params}/sign`, {baseURL: operationURL})
  },
  //  确认签署合同
  contractsSignConfirm(data) {
    return axios.put(`/rentercenter/v1/leasehold/contracts/${data.params}/sign`, {}, {baseURL: operationURL})
  },
  //  查看合同
  contractsCheck(data) {
    return axios.get(`/rentercenter/v1/leasehold/contracts/${data.contractId}/browse?flowId=${data.flowId}`, {baseURL: operationURL})
  },
  //  取消确认 contractId：合同id
  contractsCancel(data) {
    return axios.put(`/rentercenter/v1/leasehold/contracts/${data.params}/cancel`, {}, {baseURL: operationURL})
  },
  //  确认退房 contractId：合同id
  contractsCheckout(data) {
    return axios.put(`/rentercenter/v1/leasehold/contracts/${data.params}/checkout`, {}, {baseURL: operationURL})
  },
  //  租客不同意退房 contractId：合同id
  againstCheckout(data) {
    return axios.put(`/rentercenter/v1/leasehold/renter/against/${data.params}`, {}, {baseURL: operationURL})
  },
  //  租客撤销退房 contractId：合同id
  backoutCheckout(data) {
    return axios.put(`/rentercenter/v1/leasehold/renter/backout/${data.params}`, {}, {baseURL: operationURL})
  },
  //  租客发起退房 contractId：合同id
  renterCheckout(data) {
    return axios.put(`/rentercenter/v1/leasehold/renter/checkout/${data.params}`, data.body, {baseURL: operationURL, json: true})
  },
  getCheckoutReason() {
    return axios.get('/rentercenter/v1/leasehold/renter/checkout/reasons', {baseURL: operationURL})
  },
  /**
   * 添加租客评价信息
   * @param data
   * @returns {AxiosPromise<any>}
   */
  addRoomEvaluate (data) {
    return axios.post(`/h5/roomEvaluate/addRoomEvaluate`, data, {baseURL: operationURL, json: true});
  },
  /**
   * 查询房间基本信息
   * @param data
   * @returns {AxiosPromise<any>}
   */
  findRoomBaseInfo (data) {
    return axios.post(`/h5/roomEvaluate/findRoomBaseInfo`, data, {baseURL: operationURL});
  },
  /**
   * 加载租客评价标签
   * @param data
   * @returns {AxiosPromise<any>}
   */
  loadEvaluateTag (data) {
    return axios.post(`/h5/roomEvaluate/loadEvaluateTag`, data, {baseURL: operationURL});
  },
  /**
   * 查询租约评价信息
   * @param data
   * @returns {AxiosPromise<any>}
   */
  queryRentOrderEvaluateInfo (data) {
    return axios.post(`/h5/roomEvaluate/queryRentOrderEvaluateInfo`, data, {baseURL: operationURL});
  },
  //获取十一活动品牌信息
  getActivityBrand(data) {
    return axios.get(`/cms/getActivityBrand`, { params: data, baseURL: axios.defaults.renterOperation });
  },
  //获取十一活动经纪人信息
  getActivityBroker(data) {
    return axios.get(`/cms/getActivityBroker`, { params: data, baseURL: axios.defaults.renterOperation });
  },
  //获取十一活动二房东信息
  getActivityLandlord(data) {
    return axios.get(`/cms/getActivityLandlord`, { params: data, baseURL: axios.defaults.renterOperation });
  },
  //十一活动参与者信息
  getActivityUser(data) {
    return axios.get(`/cms/getActivityUser`, { params: data, baseURL: axios.defaults.renterOperation });
  },
  //根据城市id,类型查询区域信息
  getAreaInfoByType(data) {
    return axios.get(`/cms/getAreaInfoByType`, { params: data, baseURL: axios.defaults.renterOperation });
  },
  //根据城市id,查询活动标签
  getGqActivityTag(data){
    return axios.get(`/cms/getGqActivityTag`, {params: data, baseURL: axios.defaults.renterOperation});
  },
  //  初始化添加生活费账单 contractId为租约id
  initAddBill(data) {
    return axios.get(`rentercenter/v1/leasehold/initAddBill`, {params: data, baseURL: operationURL})
  },
  //  添加生活费账单 contractId为租约id
  showAddBill(data = {params: {}, config: {}}) {
    return axios.post(`rentercenter/v1/leasehold/addBill?${qs.stringify(data.params)}`, {}, {baseURL: operationURL})
  },
  bannerConfig(data) {
    return axios.post('/H5/v2/bannerConfig', data, {baseURL: axios.defaults.renterOperation})
  },
  //  获取用户对应房东下租约信息
  getRenterInfoWithLandlordId(data) {
    return axios.post('/info/getRenterInfoWithLandlordId', data, {baseURL: axios.defaults.renterOperation})
  },
  getSuperBrands(data) {
    return axios.get('/brandBulletin/getSuperBrands', {baseURL: axios.defaults.renterOperation, params: data,})
  },
  getSuperBrandsCityList(data) {
    return axios.get('/brandBulletin/getCityList', {baseURL: axios.defaults.renterOperation, params: data,})
  },
  getBrandDetailInfo(data) {
    return axios.post(`/brand/init`, data, {baseURL: axios.defaults.renterOperation})
  },
  addUserInfo(data){
    return axios.post('/info/addUserInfo', data, {baseURL: axios.defaults.renterOperation})
  },
  //  查询房东信息
  getLandordInfo(data) {
    return axios.post('/v2/roomSupplierSearch/getLandordInfo', data, {baseURL: axios.defaults.renterOperation})
  },
  /**
   * 经纪人下线老爷爷接口
   * */
  getBrokerByBrokerIdNew(data) {
    return axios.post('/v2/roomSupplierSearch/getBrokerByBrokerId', data, {baseURL: axios.defaults.renterOperation})
  },
  //  --------------   报修api ---------------------
  //  报修列表
  getRepairList(data){
    return axios.post('/repair/listRepairPage', data, {baseURL: axios.defaults.renterOperation})
  },
  //  报修详情
  getRepairDetail(data){
    return axios.post('/repair/detail', data, {baseURL: axios.defaults.renterOperation})
  },
  //  初始化报修
  getRepairInitInfo(data){
    return axios.post('/repair/initRepairInfo', data, {baseURL: axios.defaults.renterOperation})
  },
  //  报修提交
  saveRepairInfo(data) {
    return axios.post('/repair/saveRepairInfo', data, {baseURL: axios.defaults.renterOperation})
  },
  //  报修编辑提交
  updateRepairInfo(data) {
    return axios.post('/repair/updateRepairInfo', data, {baseURL: axios.defaults.renterOperation})
  },
  //  报修删除
  deleteRepairInfo(data) {
    return axios.post('/repair/removeRepairInfo', data, {baseURL: axios.defaults.renterOperation})
  },
  //  --------------   报修api ---------------------
  /**
   * 查询房源房东电话
   */
  //  报修删除
  contactLandlordInfo(data) {
    return axios.post('/contanct/contanctLandlord', data, {baseURL: axios.defaults.renterOperation})
  },
  getFastContactLandlordFacadeDTO(data) {
    return axios.post('/contanct/getFastContactLandlordFacadeDTO', data, {baseURL: axios.defaults.renterOperation})
  },
  findRepairConfigs(data) {
    return axios.get('/repair/findRepairConfigs', {baseURL: axios.defaults.renterOperation,params:data})
  },
  /**
   * 房东No转id
   */
  getLandordInfoByKey(data) {
    return axios.post('/v2/roomSupplierSearch/getLandordInfoByKey', data, {baseURL: axios.defaults.renterOperation})
  },

  //  --------------   租客问题api ---------------------
  // 问题列表
  getComplaintList(data){
    return axios.get('/renterQuestion/queryComplaintList', {baseURL: operationURL, params: data})
  },
  // 问题类型
  getComplaintTypes(){
    return axios.get('/renterQuestion/complaintTypes', {baseURL: operationURL})
  },
  // 问题详情
  getQuestionDetail(data){
    return axios.get('/renterQuestion/queryComplaintInfo', {baseURL: operationURL, params: data})
  },
  // 初始化问题
  getQuestionInitInfo(data){
    return axios.post('/repair/initRepairInfo', data, {baseURL: operationURL})
  },
  // 问题提交
  saveQuestionInfo(data) {
    return axios.post('/renterQuestion/addComplaint', data, {baseURL: operationURL, json: true})
  },
  // 客服介入
  customerAppeal(data) {
    return axios.post('/renterQuestion/customerAppeal', data, {baseURL: operationURL, json: true})
  },
  // 问题编辑提交
  updateQuestionInfo(data) {
    return axios.post('/renterQuestion/modifyComplaintInfo', data, {baseURL: operationURL, json: true})
  },
  // 删除问题
  deleteQuestionInfo(data) {
    return axios.post('/renterQuestion/deleteComplaintInfo', data, {baseURL: operationURL})
  },
  //  --------------   租客问题api ---------------------
  // 转租
  queryRoomInfo(data) {
    return axios.get('/sublet/queryRoomInfo', {baseURL: operationURL, params: data})
  },
  // 转租
  querySubletInfo(data) {
    return axios.get('/sublet/querySubletInfo', {baseURL: operationURL, params: data})
  },
  // 转租表单
  saveSublet(data) {
    return axios.post('/sublet/saveSublet', data, {baseURL: operationURL})
  },
  // 转租下架
  offlineSublet(data) {
    return axios.post('/sublet/offlineSublet', data, {baseURL: operationURL})
  },
  // 转租联系发布人
  generateVirtualNum(data) {
    return axios.post('/sublet/generateVirtualNum', data, {baseURL: operationURL})
  }
}



// WEBPACK FOOTER //
// ./src/api/renterOperation.js